import { render, staticRenderFns } from "./EmptyTestings.vue?vue&type=template&id=081839ac&scoped=true"
import script from "./EmptyTestings.vue?vue&type=script&lang=ts"
export * from "./EmptyTestings.vue?vue&type=script&lang=ts"
import style0 from "./EmptyTestings.vue?vue&type=style&index=0&id=081839ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081839ac",
  null
  
)

export default component.exports